// 文章盘点数据（纯静态展示用）
export type Article = {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  cover: string;
  date: string;
  read: string;
  author: string;
  views: string;
  tags: string[];
  hot?: boolean;
  content: string[];
};

export const articles: Article[] = [
  {
    slug: "fangyan-72h",
    title: "「顶流×素人」恋情曝光 72 小时全复盘：从同框到官宣的完整脉络",
    excerpt: "一条被网友放大的同框照片，如何演变成一场持续三天的全民围观？我们按时间线重演了这段恋情的每一次关键推进。",
    category: "starlove",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20a%20phone%20screen%20closeup%20showing%20a%20blurred%20candid%20photo%20of%20two%20people%2C%20dramatic%20warm%20spotlight%2C%20rose%20red%20and%20gold%20tones%2C%20speculative%20gossip%20magazine%20mood%2C%20film%20grain%2C%20mysterious%20glow&width=1200&height=760&seq=ar-fangyan&orientation=landscape",
    date: "2026-09-02",
    read: "8 分钟",
    author: "编辑部",
    views: "38.6万",
    tags: ["明星情感", "时间线", "全网复盘"],
    hot: true,
    content: [
      "一切始于某天深夜，一张被截图放大的同框图开始在几个追星超话间流转。起初它只是「有点像」的猜测，配文多是「蹲一个解释」，很少有人料到它会在 48 小时内演变成一场全网围观的情感连续剧。",
      "复盘这段脉络，我们会发现每一步都踩在信息的空窗期上：当事方沉默的每 24 小时，都会催生新的「时间线整理帖」；而每一次从不同渠道流出的「侧面回应」，又会让舆论短暂地偏向某一方。我们整理了同框图出现、多个账号搬运拼图、正面回应与最终官宣这四个节点，试图还原情绪如何被层层放大。",
      "最值得注意的是舆论反转的节点。当第一条带具体时间戳的「实锤物料」出现后，先前「只是朋友」的说法迅速被推翻，讨论也从「是不是真的」转向「还有多少细节没被挖出来」。评论区里，理性派与情绪派的分歧，几乎成了一场小型舆论实验。",
      "把散落的信息拼回一条时间线，你会发现「实锤」从不是某个瞬间的事，而是一连串选择叠加的结果。这也是我们做吃瓜精选中「时间线专题」的初衷：不替你做判断，但把过程摊给你看。",
    ],
  },
  {
    slug: "lianai-script",
    title: "恋爱综艺里的「剧本感」：高甜名场面，真的只是一场秀吗",
    excerpt: "「有剧本」和「全无剧本」之间其实隔着很宽的地带。拆开一档恋综的选人、流程与剪辑，看看那些心动瞬间是怎么被做出来的。",
    category: "starlove",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20a%20candlelit%20romantic%20dinner%20table%20set%20for%20two%20in%20a%20warm%20studio%2C%20soft%20gold%20bokeh%2C%20rose%20petals%2C%20dating%20show%20mood%2C%20terracotta%20and%20crimson%20tones%2C%20film%20grain%2C%20magazine%20art&width=1200&height=760&seq=ar-lianscript&orientation=landscape",
    date: "2026-08-28",
    read: "7 分钟",
    author: "编辑部",
    views: "22.1万",
    tags: ["明星情感", "综艺", "恋综拆解"],
    content: [
      "每当恋综里出现一段「高甜告白」，弹幕总少不了「都是剧本」的调侃。但如果把所有互动都简单归因于剧本，反而错过了节目制作的真实逻辑：制作组搭建情境、设定规则与节点，真正的情感则发生在镜头允许的缝隙里。",
      "从选人环节看，嘉宾的画像搭配本身就带着话题预设：有人负责一见钟情，有人负责虐恋拉扯，也有人负责清醒发言。规则的设置（比如固定的心动环节与选择机制）会在固定时间点制造情绪峰值——这正是「名场面」被反复回味的结构基础。",
      "真正让观众上头的，往往是框架之外的那些「失控瞬间」：一句没写进台本的真心话、一次下意识的肢体反应。剪辑师要做的，就是把框架之内的铺垫与框架之外的真实穿插起来，让观众既感受到设计感，又愿意相信心动是真的。",
      "所以「有剧本吗」这个问题的更准确答案是：它更像一场被搭好舞台的即兴戏剧。舞台是真的，即兴也是真的——只是你看到的，始终是导演选择的那个机位。",
    ],
  },
  {
    slug: "cp-three-years",
    title: "分分合合三年，这对 CP 为何总能被拍到「又在一起」",
    excerpt: "从官宣、分手到同框复合，三年间的每一次反复都有迹可循。我们把这对荧幕情侣的高频节点整理成一份完整档案。",
    category: "starlove",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20two%20warm%20silhouettes%20walking%20together%20through%20golden%20sunlight%20and%20long%20shadows%2C%20on%20and%20off%20again%20romance%20mood%2C%20rose%20and%20amber%20palette%2C%20film%20grain%2C%20magazine%20storytelling%2C%20soft%20light&width=1200&height=760&seq=ar-cpthree&orientation=landscape",
    date: "2026-08-20",
    read: "6 分钟",
    author: "编辑部",
    views: "15.8万",
    tags: ["明星情感", "复合", "完整档案"],
    content: [
      "「分又没分成、合又没公开」大概是这对 CP 三年来最真实的写照。翻看这份时间线档案会发现，每一次「分手」与「复合」之间，都夹着剧宣档期、品牌合作与工作安排的复杂考量，情感与工作几乎无法被分开看待。",
      "我们把三个关键周期拆开：第一次被拍到的热恋期、中间那场以「性格不合」收尾的官宣分手，以及近期频繁同框的「疑似复合」阶段。有意思的是，三个阶段都伴随着各自的作品上线，舆论情绪也随之在「祝福」与「炒作」之间反复横跳。",
      "作为旁观者，我们其实很难确知真相。但把三年的碎片放到一起，至少能让你跳出单条八卦的局限，看到一段关系在镜头内外被反复折叠的全貌——至于最后是喜剧还是悬疑，只能交给时间去揭晓。",
    ],
  },
  {
    slug: "xuanxiu-flow",
    title: "从海选到成团：一条完整的造星流水线是如何运转的",
    excerpt: "海选、评级、打投、出道……选秀是一个被精确计算过的工业系统。我们顺着流程往下拆，看一档节目如何把素人「加工」成偶像。",
    category: "backstage",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20an%20audition%20hall%20with%20numbered%20backstage%20doors%20and%20waiting%20dancers%20silhouetted%20in%20warm%20spotlight%2C%20showbiz%20industry%20mood%2C%20crimson%20and%20gold%2C%20cinematic%20film%20grain%2C%20documentary%20style&width=1200&height=760&seq=ar-xuanxiu&orientation=landscape",
    date: "2026-09-05",
    read: "9 分钟",
    author: "编辑部",
    views: "29.4万",
    tags: ["行业秘闻", "选秀", "造星工业"],
    hot: true,
    content: [
      "一档选秀节目看起来是「素人追梦」，实际上是高度工业化的内容生产：选手在开播前数月就要通过多轮线下海选、视频筛选与背景评估，真正站上首舞台的人，往往已是万里挑一的「半成品」。",
      "进入正片后，评级、分组、主题考核构成了三条清晰的生产线。每个阶段的赛制都服务于同一目标——在有限镜头内最大化戏剧冲突与观众黏性。「逆袭剧本」「遗憾淘汰」并非偶然，而是剪辑在无数素材中精心挑选出来的叙事线。",
      "打投环节则是整个工业系统里争议最大的齿轮。榜单机制的每一次升级，都在用户「为爱发电」与平台商业化之间重新划界，也直接催生了「数据打投乱象」这一长期被热议的行业议题（参见《打投乱象复盘》）。",
      "当我们把这条流水线完整摊开，会意识到「成团」既是一个梦想的终点，也只是一个更长产业链的起点。看懂它，才算真正看懂了这一场场全民参与的「造星实验」。",
    ],
  },
  {
    slug: "datou-pool",
    title: "打投乱象复盘：一张「人气榜单」背后到底藏着什么",
    excerpt: "打投机制如何把粉丝热情变成商业数据，又为何频频翻车？我们从榜单规则、账号经济与监管尺度三端把这件事拆明白。",
    category: "backstage",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20piles%20of%20voting%20cards%20and%20dairy%20carton%20towers%20on%20a%20desk%2C%20bright%20ranking%20chart%20glowing%20in%20background%2C%20voting%20fandom%20economy%20theme%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20still%20life%2C%20film%20grain&width=1200&height=760&seq=ar-datou&orientation=landscape",
    date: "2026-08-15",
    read: "7 分钟",
    author: "编辑部",
    views: "31.2万",
    tags: ["行业秘闻", "打投", "榜单经济"],
    content: [
      "「让偶像的排名再往上一点」是无数粉丝最朴素也最烧钱的愿望。打投乱象的根源，在于把「热爱」直接折算成了可重复消费的数据：积分、任务、多账号轮切，最终都指向同一件事——用资源换取榜单位次。",
      "从规则端看，榜单机制的每一次「加码」，都会带来参与门槛与情绪动员的双重升级；而从账号经济看，代打、养号、刷量早已形成一条灰色产业链，把粉丝的集体热情变成了可以被计价的流量流水。",
      "监管与平台的介入，让这场游戏开始收敛：清朗行动、理性追星倡议、榜单入口整改……政策在压缩空间的同时，也倒逼平台重新思考「数据透明」与「责任边界」。",
      "这场复盘想说明的不只是「谁在赚谁的钱」，更是当参与感被结构化成任务与数据时，热爱本身如何被消耗。看懂机制，也许比看懂某个榜单名次更重要。",
    ],
  },
  {
    slug: "first-contract",
    title: "新人第一次签经纪约，到底该盯紧哪几行字",
    excerpt: "分成比例、长约锁定期、约满归属……我们整理了行业里反复出现的合同争议点，给准备入行的新人一份可对标的清单。",
    category: "backstage",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20hands%20signing%20a%20contract%20on%20a%20warm%20wooden%20desk%20with%20gold%20fountain%20pen%2C%20stack%20of%20paper%20documents%20and%20soft%20lamp%20light%2C%20showbiz%20legal%20industry%20mood%2C%20crimson%20and%20amber%20tones%2C%20cinematic%20film%20grain&width=1200&height=760&seq=ar-contract&orientation=landscape",
    date: "2026-07-30",
    read: "8 分钟",
    author: "编辑部",
    views: "12.6万",
    tags: ["行业秘闻", "经纪约", "避坑指南"],
    content: [
      "对大多数怀揣舞台梦的新人来说，第一份经纪约既是一份期待，也是一道未必读得懂的厚册。行业里反复出现的争议，往往集中在几个「小字」上：收益分成的基础是税前还是税后、费用报销是否先行垫付、以及「约满后作品版权归谁」。",
      "锁定期是另一个高频雷区。过长的自动续约条款、苛刻的违约赔偿金，都可能在签下的那一刻埋下日后的麻烦。我们建议新人重点关注：期限结构、解约路径、分成基数、知识产权归属、以及争议的管辖与律师费承担。",
      "当然，规则未必处处公平，但看懂条款至少能让你在谈判桌上拥有底气。这份清单的目的，不是劝退任何人的梦想，而是让追梦的第一步，走得稍微清醒一点。",
    ],
  },
  {
    slug: "ai-love-shows",
    title: "恋综的高甜与高冷：一档「谈感情」的节目现场是如何被做出来的",
    excerpt: "心动小屋的每一盏灯、每一场对话都有讲究。我们走进恋综现场，看看那些高甜瞬间背后的流程、选人与引导。",
    category: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20a%20cozy%20modern%20villa%20living%20room%20set%20designed%20for%20a%20dating%20show%20with%20warm%20string%20lights%2C%20armchairs%20and%20a%20fireplace%2C%20candles%2C%20romantic%20warm%20ambiance%2C%20rose%20and%20gold%20tones%2C%20film%20grain&width=1200&height=760&seq=ar-ailove&orientation=landscape",
    date: "2026-08-25",
    read: "7 分钟",
    author: "编辑部",
    views: "19.9万",
    tags: ["综艺现场", "恋综", "幕后拆解"],
    content: [
      "很多人好奇：恋综里那套被布置得恰到好处的心动小屋，到底是自然发生还是被精心设计？答案是两者都有。场景、灯光、甚至摄影机的位置，都在为「让感情发生并被看见」服务。",
      "选人是最关键的环节。节目组会在海量报名者中寻找「化学反应的潜力组合」：性格互补、颜值配搭、话题度匹配，都是为了在有限的相处周期里提高「出彩概率」。这与《恋爱综艺里的剧本感》里谈到的逻辑一脉相承。",
      "拍摄阶段，导演组的引导往往「软」于真人秀、却「硬」于普通记录：通过游戏、任务与谈心环节把镜头内的人推向特定的相处情境，但具体会擦出怎样的火花，则交给真实反应。",
      "当我们把恋综的现场规则摊开，会发现所谓「高甜」其实建立在严密的流程之上——这也是为什么它能稳定地产出名场面，又始终让人愿意相信镜头里曾有过几分真心。",
    ],
  },
  {
    slug: "slow-variety",
    title: "一档慢综艺的诞生：现场的真实与设计之间隔着一层什么",
    excerpt: "慢综艺主打「真实生活」，但它的节奏、人选与场景同样经过精密设计。我们拆开这层「慢」，看看真实从何而来。",
    category: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20rural%20courtyard%20kitchen%20with%20steam%20rising%20from%20a%20warm%20stove%2C%20cozy%20cottage%20table%20with%20ingredients%2C%20slow%20tv%20variety%20mood%2C%20golden%20afternoon%20light%2C%20warm%20terracotta%20tones%2C%20cinematic%20film%20grain&width=1200&height=760&seq=ar-slowvar&orientation=landscape",
    date: "2026-08-08",
    read: "6 分钟",
    author: "编辑部",
    views: "14.3万",
    tags: ["综艺现场", "慢综艺", "拍摄幕后"],
    content: [
      "慢综艺卖点是「逃离都市、回归生活」，但把它做成一档节目，本身就是一项精细的工程。选址、常驻人设、日程留白比例，甚至住在一起的房间分配，都经过前期多轮推演——「真实感」反而是被设计出来的目标。",
      "拍摄现场的矛盾在于：既要保留生活的偶然性，又要保证节目有内容密度。为此节目组会设置必要的「生活事件」——一起采购、一次突发天气、一顿失败的晚餐——让镜头内的人物有机会展现真实的情绪反应。",
      "剪辑层面，慢综艺追求的是「去戏剧化的叙事」：它很少靠强冲突推进，而是用细节、闲谈与季节流转铺陈情绪。观众之所以觉得治愈，正是这种被柔化处理后的时间感在起作用。",
      "所以「真实」在这里是相对概念：人物是真实的，生活场景是真实的，但把这些真实拼成一档可看的节目，离不开一层看不见的设计。拆开它，反而更能欣赏那份「慢」。",
    ],
  },
  {
    slug: "kaichang-moments",
    title: "综艺名场面大盘点：为什么有些瞬间能让观众反复回味",
    excerpt: "一句出圈的台词、一次破防的失控、一个被剪辑封神的回头……我们盘点那些刻进网友 DNA 的名场面，拆解它们为何上头。",
    category: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20editorial%20photography%20of%20a%20montage%20of%20glowing%20video%20screens%20with%20freeze%20frames%20and%20famous%20talk%20show%20stage%20spotlights%2C%20energetic%20crowd%20reaction%2C%20warm%20gold%20and%20terracotta%20tones%2C%20cinematic%20grain%2C%20magazine%20feature&width=1200&height=760&seq=ar-moments&orientation=landscape",
    date: "2026-07-22",
    read: "6 分钟",
    author: "编辑部",
    views: "26.7万",
    tags: ["综艺现场", "名场面", "盘点"],
    content: [
      "所谓「名场面」，往往在诞生时只是现场一个自然发生的瞬间，却在传播中被不断切片、二次创作，最终成为一个可以被反复引用的大众梗。一句出圈台词，往往自带「高识别 + 可模仿 + 有情绪」的属性。",
      "从类型看，名场面大致分三类：一是「失控的真诚」，比如艺人在压力下的真实破防，它满足观众对「真人」的期待；二是「即兴的机敏」，一句没台本的接梗封神，考验的是临场反应；三是「被剪辑点亮的瞬间」，一个回头、一个对视，经慢放与配乐后被赋予新的叙事意义。",
      "我们把近年来热度最高的若干场面做了归档：它们来自不同类型的节目，却共享同一套传播逻辑——足够短的时长、足够大的情绪落点、以及足够强的「可被解读」空间。",
      "看懂这套逻辑，下次当你为一个片段反复上头时，也许能更清楚地知道：打动你的，既是那个真实的瞬间，也是整个生产链上所有人共同托举的结果。",
    ],
  },
  {
    slug: "zhuchichang-suanfa",
    title: "常驻嘉宾人选背后，藏着一套怎样的「综艺算法」",
    excerpt: "为什么这档节目定他、那档节目定她？选常驻不只看流量，综艺感、化学反应与档期共同构成一套看不见的算法。",
    category: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20team%20seated%20around%20a%20glowing%20round%20table%20on%20a%20studio%20set%2C%20talk%20show%20hosts%20cast%20silhouettes%2C%20warm%20gold%20spotlight%20from%20above%2C%20crimson%20and%20amber%20tones%2C%20cinematic%20film%20grain%2C%20casting%20meeting%20mood&width=1200&height=760&seq=ar-zhuchichang&orientation=landscape",
    date: "2026-07-10",
    read: "5 分钟",
    author: "编辑部",
    views: "11.5万",
    tags: ["综艺现场", "选角", "行业拆解"],
    content: [
      "一档综艺的口碑与热度，往往在嘉宾名单公布那一刻就被初步锁定。选常驻看起来是「谁红选谁」，但在制片人眼中，真正要拼的是几个维度的叠加：辨识度、综艺感、情绪能量与团队之间的化学反应。",
      "「综艺感」是其中最玄学也最核心的指标——它不等于话多，而在于能否自然地把普通场景变成有效素材。有些人自带金句体质，有些人擅长接梗递话，有些人则负责情绪托底，一个健康的班底通常需要不同类型的角色互补。",
      "除此之外，档期稳定性、商务配合度、以及彼此间已有的「话题关联」也会进入考量。你会发现很多成功的组合，往往在选角阶段就预埋了「化学反应」的种子——把合适的人放进合适的关系网，名场面便有了诞生的土壤。",
    ],
  },
  {
    slug: "hotsearch-timeline",
    title: "一场热搜的完整时间线：消息如何被放大、歪曲与反转",
    excerpt: "从首发爆料到官方澄清，一场热搜的每一步都牵动舆论。我们复盘一条典型热搜的生命周期，看看情绪是如何被结构驱动的。",
    category: "society",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20wall%20of%20glowing%20smartphone%20screens%20showing%20trending%20timeline%20feeds%2C%20fast%20moving%20digital%20news%20mood%2C%20warm%20amber%20and%20crimson%20neon%2C%20motion%20blur%2C%20cinematic%20film%20grain%2C%20modern%20editorial&width=1200&height=760&seq=ar-hotsearch&orientation=landscape",
    date: "2026-09-01",
    read: "8 分钟",
    author: "编辑部",
    views: "41.9万",
    tags: ["社会热议", "热搜", "时间线"],
    hot: true,
    content: [
      "一条热搜的生命，通常可以拆成四段：首发、放大、反转、落幕。首发往往来自某个小圈子的内部爆料，配图模糊、信息残缺，却是整件事的引信；随后，搬运号与情绪化解读让它迅速破圈，讨论从「发生了什么」滑向「我该站哪边」。",
      "放大的关键在于空窗期：当事方回应越慢，二次创作的空间越大。此时往往会出现「时间线整理」「对比实锤」等衍生内容，它们看起来中立，实则也带着各自的框架。当多个版本互相矛盾，舆论便进入情绪峰值。",
      "反转通常由一份带完整证据的官方回应触发。有意思的是，反转很少让所有人同时冷静下来——先前被情绪动员的人，需要付出额外的认知成本去接受「我可能看错了」。这也是为什么反转的讨论往往比原事件更激烈。",
      "复盘整条时间线，最值得记取的或许不是谁对谁错，而是一句提醒：在信息未完整时，先别急着给任何人定罪。保持对「片段」的警惕，是数字时代一种重要的素养。",
    ],
  },
  {
    slug: "daibohuofan",
    title: "直播带货翻车复盘：流量退潮之后，还剩下什么",
    excerpt: "从一夜爆单到口碑危机，直播带货的兴衰周期被大幅压缩。我们复盘典型的「翻车」路径，聊聊信任这门生意的边界。",
    category: "society",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20live%20streaming%20studio%20desk%20with%20ring%20light%2C%20microphone%20and%20product%20boxes%2C%20monitor%20showing%20declining%20charts%2C%20commerce%20crash%20mood%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20film%20grain%2C%20modern%20editorial&width=1200&height=760&seq=ar-daibohuo&orientation=landscape",
    date: "2026-07-18",
    read: "7 分钟",
    author: "编辑部",
    views: "18.2万",
    tags: ["社会热议", "直播带货", "复盘"],
    content: [
      "直播带货的迷人之处在于它的即时爆发力：一场直播能卖出传统渠道数月才能达成的销量。但成也流量、败也流量，当选品、售后或宣传话术出现问题时，塌房的速度同样惊人——信任一旦透支，很难靠下一次「全网最低价」补回来。",
      "翻车常见的路径有三条：一是货不对板，「超低价」背后是缩水或临期产品；二是夸大宣传，功效被话术无限拔高；三是售后缺位，流量进来之后的服务跟不上，差评开始反噬主播人设。",
      "更深层的问题在于，直播间的核心竞争力本应是「帮用户把关」，但部分从业者把重心放到了「让用户下单」上。当推荐逻辑从信任滑向转化，翻车就只是时间问题。",
      "复盘这些案例，我们想说的并不是否定整个行业，而是提醒：在注意力经济里，流量能带来一时的繁荣，只有长期可靠的服务，才能让这盘生意走得更远。",
    ],
  },
  {
    slug: "yijun-observations",
    title: "「吃瓜」为什么会让人上头？聊聊围观心理背后的机制",
    excerpt: "从猎奇到共情，从站队到破防，围观一场八卦远不只是看热闹。我们从心理层面聊聊，为什么「吃瓜」如此难以自拔。",
    category: "society",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20group%20of%20friends%20huddled%20around%20a%20glowing%20phone%20at%20night%20with%20popcorn%2C%20gossip%20circle%20mood%2C%20warm%20cozy%20amber%20lighting%2C%20crimson%20and%20gold%20tones%2C%20cinematic%20film%20grain%2C%20lifestyle%20magazine&width=1200&height=760&seq=ar-psychology&orientation=landscape",
    date: "2026-06-25",
    read: "6 分钟",
    author: "编辑部",
    views: "9.8万",
    tags: ["社会热议", "心理", "吃瓜文化"],
    content: [
      "「吃瓜」最早指的是围观不关己事的八卦，如今它已演化成一种全民参与的集体仪式。心理学家倾向于认为，人们围观的动力远不止「看热闹」：它提供即时的情绪刺激，也提供一种低成本的社会联结——一起讨论一个共同话题，会让人觉得被拉近了。",
      "站队心理是吃瓜中最容易上头的一环。人在面对模糊信息时，天然倾向尽快形成判断以消除不确定性；而一旦公开站队，公开承诺又会让立场变得难以撤回，这解释了为什么很多反转里，最先崩溃的往往是那些冲在最前面的人。",
      "理解了这套机制，你或许会对自己在评论区里的情绪多一分觉察：每一次想「马上就骂」的冲动背后，可能只是大脑在急于给不确定的世界一个确定的答案。下次不妨先吃瓜、晚站队，等脉络清晰了再说。",
    ],
  },
];